module.exports = __webpack_public_path__ + "img/company_introduction.2cbdad8.webp";